import AssetInspection from "./AssetInspection"
import { Guid } from "@/types"

export interface IGetAssetInspectionPairDTO {
    reservationId?: Guid
    deliveryInspectionId?: Guid | null
    returnInspectionId?: Guid | null
    // New API structure
    deliveryInspection?: {
        shippingOrderId: Guid
        assetInspectionId: Guid
        inspectionRequired: boolean
    }
    returnInspection?: {
        shippingOrderId: Guid
        assetInspectionId: Guid
        inspectionRequired: boolean
    }
}

export default class AssetInspectionPair {
    reservationId: Guid
    deliveryInspectionId?: Guid | null
    returnInspectionId?: Guid | null
    deliveryInspection?: AssetInspection | null
    returnInspection?: AssetInspection | null
    // Additional useful properties from the new API
    deliveryInspectionRequired?: boolean
    returnInspectionRequired?: boolean
    shippingOrderId?: Guid // Deprecated - use specific ones below
    deliveryShippingOrderId?: Guid
    returnShippingOrderId?: Guid

    constructor(dto: IGetAssetInspectionPairDTO) {
        // Handle new API structure
        if (dto.deliveryInspection || dto.returnInspection) {
            // Extract information from the new nested structure
            this.reservationId = dto.reservationId || '' // Will be set by the service
            this.deliveryInspectionId = dto.deliveryInspection?.assetInspectionId || null
            this.returnInspectionId = dto.returnInspection?.assetInspectionId || null
            this.deliveryInspectionRequired = dto.deliveryInspection?.inspectionRequired
            this.returnInspectionRequired = dto.returnInspection?.inspectionRequired
            // Store specific shipping order IDs
            this.deliveryShippingOrderId = dto.deliveryInspection?.shippingOrderId
            this.returnShippingOrderId = dto.returnInspection?.shippingOrderId
            // Keep backward compatibility with old shippingOrderId
            this.shippingOrderId = dto.deliveryInspection?.shippingOrderId || dto.returnInspection?.shippingOrderId
        } else {
            // Handle old fallback structure
            this.reservationId = dto.reservationId || ''
            this.deliveryInspectionId = dto.deliveryInspectionId || null
            this.returnInspectionId = dto.returnInspectionId || null
            this.deliveryInspectionRequired = undefined
            this.returnInspectionRequired = undefined
            this.shippingOrderId = undefined
            this.deliveryShippingOrderId = undefined
            this.returnShippingOrderId = undefined
        }

        this.deliveryInspection = null
        this.returnInspection = null
    }

    // Method to populate inspection data when fetched separately
    setInspections(inspections: AssetInspection[]) {
        if (this.deliveryInspectionId) {
            this.deliveryInspection = inspections.find(i => i.id === this.deliveryInspectionId) || null
        }
        if (this.returnInspectionId) {
            this.returnInspection = inspections.find(i => i.id === this.returnInspectionId) || null
        }
    }
}
